export function useProductTierPricing(product) {
    const quantityStore = useProductQuantityStore();

    watch(
        () => quantityStore.quantities[product.id],
        (newQuantity) => {
            if (!newQuantity || newQuantity <= 0) {
                return;
            }
            product.totalPrice = product.raw_gross_price * (newQuantity || 1);

            if (product.is_special) {
                return;
            }

            const foundPrice = quantityStore.getPriceBasedOnQuantity(product, newQuantity);

            if (foundPrice) {
                product.gross_price = foundPrice.gross_price;
                product.totalPrice = foundPrice.raw_gross_price * (newQuantity || 1);
                product.net_price = foundPrice.net_price;
                product.premium_percent = foundPrice.premium_percent;
                product.premium_value = foundPrice.premium_value;
            }
        },
        { immediate: true }
    );
}
